import {useState} from 'react';

import Action from 'components/design-guide/Action';
import {ActionStyle, ActionType, ButtonStyle, ButtonWidth} from 'components/design-guide/enums';
import ConfirmationPrompt from 'shared/components/ConfirmationPrompt';
import FormattedMessage from 'shared/IntlFormatMessage/components/FormattedMessage';
import {GLOBAL_TRANSLATIONS} from 'shared/IntlFormatMessage/translations/globalTranslations';
import {useAdobeTargetGlobalMBox} from 'utils/adobe-target';
import {SafelyParseHTML} from 'utils/parse-html';

const AEMModal = () => {
  const adobeTargetValues = useAdobeTargetGlobalMBox();
  const [showModal, setShowModal] = useState(true);
  const aemMessage = adobeTargetValues.modal?.aemMessage;
  if (!aemMessage) {
    return null;
  }
  const {heading, messageText} = aemMessage;
  return (
    aemMessage && (
      <ConfirmationPrompt
        name="aem-message-modal"
        isOpen={showModal}
        title={heading}
        message={<SafelyParseHTML htmlString={messageText} />}
        confirmationButton={
          <Action
            name="aem-message-modal-button"
            actionStyle={ActionStyle.BUTTON}
            styleProps={{
              buttonStyle: ButtonStyle.SECONDARY,
              width: ButtonWidth.FULL_AT_MOBILE
            }}
            actionType={ActionType.ONCLICK}
            typeProps={{type: 'button', onClick: () => setShowModal(false)}}>
            <FormattedMessage message={GLOBAL_TRANSLATIONS.I_UNDERSTAND} />
          </Action>
        }
      />
    )
  );
};

export default AEMModal;
